import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCategoryList } from "../../../Api/api";


// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const categoryListAsync=createAsyncThunk(
   "vehicle-category/list",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await getCategoryList();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const categoryMasterSlice = createSlice({
   name: "companyMaster",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(categoryListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(categoryListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(categoryListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default categoryMasterSlice.reducer;